import { tx } from "@/i18n/tx";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import ConfirmAction from "@/components/ConfirmAction";
import { UserCheck, Copy, Trash2 } from "lucide-react";

export default function FiduciaryAccessCard({ defaultEmail }) {
  const [items, setItems] = useState([]);
  const [email, setEmail] = useState(defaultEmail || "");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/fiduciary/access").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const grant = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/fiduciary/access", { email });
      toast.success(tx("tpl.access_sent", { email }));
      load();
    } catch {
      toast.error(tx("r3.bad_email"));
    } finally { setBusy(false); }
  };

  const revoke = async (id) => {
    await api.delete(`/fiduciary/access/${id}`);
    toast.success(tx("ui_fiduciaryaccesscard.kf6f95b"));
    load();
  };

  const copy = (link) => navigator.clipboard?.writeText(link).then(() => toast.success(tx("ui_fiduciaryaccesscard.k0e1da1")));

  return (
    <div className="card-c" data-testid="fiduciary-access-card">
      <div className="flex items-center gap-2 mb-1">
        <UserCheck className="w-5 h-5 text-primary-c" />
        <p className="text-xs uppercase tracking-wider text-text-secondary font-semibold">{tx("ui_fiduciaryaccesscard.k2d28a5")}</p>
      </div>
      <p className="text-[11px] text-text-secondary mb-3">{tx("ui_fiduciaryaccesscard.kb85504")}</p>
      <form onSubmit={grant} className="flex gap-2">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder={tx("onb.fid_ph")} className="input-c text-sm flex-1 min-w-0" data-testid="fiduciary-email-input" />
        <button disabled={busy} className="btn-primary !py-2 !px-4 text-sm shrink-0" data-testid="fiduciary-grant-btn">{tx("ui_fiduciaryaccesscard.k9d5680")}</button>
      </form>
      {items.length > 0 && (
        <ul className="mt-3 space-y-2" data-testid="fiduciary-access-list">
          {items.map((i) => (
            <li key={i.id} className="flex items-center gap-2 p-2.5 rounded-xl bg-surface-muted">
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold truncate">{i.email}</p>
                <p className="text-[11px] text-text-secondary">{i.last_access_at ? tx("tpl.last_access", { date: new Date(i.last_access_at).toLocaleDateString("fr-CH") }) : tx("ui_fiduciaryaccesscard.k765593")}</p>
              </div>
              <button onClick={() => copy(i.link)} className="p-2 rounded-lg hover:bg-white" aria-label={tx("ui_fiduciaryaccesscard.k359419")} data-testid={`fiduciary-copy-${i.id}`}><Copy className="w-4 h-4" /></button>
              <ConfirmAction testId={`fiduciary-revoke-${i.id}`} title={tx("ui_fiduciaryaccesscard.k44fbb2")} description={`Le lien de ${i.email} ne fonctionnera plus.`} confirmLabel={tx("ui_fiduciaryaccesscard.k1b74da")} onConfirm={() => revoke(i.id)}>
                <button className="p-2 rounded-lg hover:bg-white text-red-600" aria-label={tx("ui_fiduciaryaccesscard.k1b74da")} data-testid={`fiduciary-revoke-${i.id}`}><Trash2 className="w-4 h-4" /></button>
              </ConfirmAction>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
